<template>
  <div>
    <div class="row">
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_HEIGHT') }}</div>
        <div v-for="n in heightOptions()" :key="n" class="unit-option">
          <input :id="'u-height-'+ formatOption(n)" type="radio" :value="n" v-model="this.heightUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_LENGTH') }}</div>
        <div v-for="n in lengthOptions()" :key="n" class="unit-option">
          <input :id="'u-length-'+ formatOption(n)" type="radio" :value="n" v-model="this.lengthUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_PRESSURE') }}</div>
        <div v-for="n in pressureOptions()" :key="n" class="unit-option">
          <input :id="'u-pressure-'+ formatOption(n)" type="radio" :value="n" v-model="this.pressureUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_AREAS') }}</div>
        <div v-for="n in areaOptions()" :key="n" class="unit-option">
          <input :id="'u-areas-'+ formatOption(n)" type="radio" :value="n" v-model="this.areaUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_FLOW') }}</div>
        <div v-for="n in flowOptions()" :key="n" class="unit-option">
          <input :id="'u-flow-'+ formatOption(n)" type="radio" :value="n" v-model="this.flowUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_RATE') }}</div>
        <div v-for="n in rateOptions()" :key="n" class="unit-option">
          <input :id="'u-rate-'+ formatOption(n)" type="radio" :value="n" v-model="this.rateUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_PRECIP') }}</div>
        <div v-for="n in precipOptions()" :key="n" class="unit-option">
          <input :id="'u-precip-'+ formatOption(n)" type="radio" :value="n" v-model="this.precipUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
      <div class="unit-column">
        <div class="unit-title">{{ $t('LBL_UNIT_SPEED') }}</div>
        <div v-for="n in speedOptions()" :key="n" class="unit-option">
          <input :id="'u-speed-'+ formatOption(n)" type="radio" :value="n" v-model="this.speedUnit">
          <label :for="n">{{ n }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSettingsStore } from '@/stores/SettingsStore.js';

export default {
  computed: {
    heightUnit: {
      get () {
        return useSettingsStore().heightUnit;
      },
      set (value) {
        useSettingsStore().setHeightUnit(value);
      },
    },
    lengthUnit: {
      get () {
        return useSettingsStore().lengthUnit;
      },
      set (value) {
        useSettingsStore().setLengthUnit(value);
      },
    },
    pressureUnit: {
      get () {
        return useSettingsStore().pressureUnit;
      },
      set (value) {
        useSettingsStore().setPressureUnit(value);
      },
    },
    areaUnit: {
      get () {
        return useSettingsStore().areaUnit;
      },
      set (value) {
        useSettingsStore().setAreaUnit(value);
      },
    },
    flowUnit: {
      get () {
        return useSettingsStore().flowUnit;
      },
      set (value) {
        useSettingsStore().setFlowUnit(value);
      },
    },
    rateUnit: {
      get () {
        return useSettingsStore().rateUnit;
      },
      set (value) {
        useSettingsStore().setRateUnit(value);
      },
    },
    precipUnit: {
      get () {
        return useSettingsStore().precipUnit;
      },
      set (value) {
        useSettingsStore().setPrecipUnit(value);
      },
    },
    speedUnit: {
      get () {
        return useSettingsStore().speedUnit;
      },
      set (value) {
        useSettingsStore().setSpeedUnit(value);
      },
    },
  },
  methods: {
    formatOption (option) {
      return option.replace(/\s|\.|\//g, '-').replace(/#/g, '');
    },
    heightOptions () {
      return useSettingsStore().heightOptions;
    },
    lengthOptions () {
      return useSettingsStore().lengthOptions;
    },
    pressureOptions () {
      return useSettingsStore().pressureOptions;
    },
    areaOptions () {
      return useSettingsStore().areaOptions;
    },
    flowOptions () {
      return useSettingsStore().flowOptions;
    },
    rateOptions () {
      return useSettingsStore().rateOptions;
    },
    precipOptions () {
      return useSettingsStore().precipOptions;
    },
    speedOptions () {
      return useSettingsStore().speedOptions;
    },
  }
};
</script>

<style scoped>
.row {
  display: flex;
  flex-direction: row;
}

.unit-column {
  display: flex;
  flex-direction: column;
  width: 25%;
}

.unit-title {
  color: var(--nelson-blue);
  padding: 10px;
  text-align: center;
}

.unit-option {
  color: #444444;
  display: flex;
  flex-direction: row;
  font-size: x-large;
}
</style>
